export default __webpack_public_path__ + "img/a63743a4a3084e6eb2945b16a27b3ff7.png";